import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Products from './components/Products';
import ClientLogos from './components/ClientLogos';
import Contact from './components/Contact';
import ContactPage from './components/ContactPage';
import Footer from './components/Footer';
import VisibilityDetail from './components/VisibilityDetail';
import IntelligenceDetail from './components/IntelligenceDetail';
import DocumentsDetail from './components/DocumentsDetail';
import About from './components/About';
import Privacy from './components/Privacy';
import PageSEO from './components/common/PageSEO';
import { LanguageProvider, ROUTES, LANGS, useT } from './i18n';

const HOME_SEO = {
  es: {
    title: 'Visibilidad e Inteligencia en la Cadena de Suministro',
    description: 'Plataforma modular de visibilidad, inteligencia y documentos de transporte digitales. Trazabilidad de envíos, seguimiento en tiempo real, supply chain analytics con IA y eCMR.',
    keywords: 'visibilidad cadena de suministro, trazabilidad envíos, seguimiento tiempo real, supply chain analytics, eCMR, documento de control digital, gestión logística, ETA dinámico',
  },
  en: {
    title: 'Supply Chain Visibility & Intelligence',
    description: 'Modular platform for visibility, intelligence and digital transport documents. Shipment traceability, real-time tracking, AI-powered supply chain analytics and eCMR.',
    keywords: 'supply chain visibility, shipment traceability, real-time tracking, supply chain analytics, eCMR, digital transport documents, logistics management, dynamic ETA',
  },
};

// Página principal
function HomePage() {
  const seo = useT(HOME_SEO);
  return (
    <>
      <PageSEO
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
      />
      <Hero />
      <Products />
      <ClientLogos />
      <Contact />
    </>
  );
}

// Componente por página canónica; las rutas se generan para cada idioma desde ROUTES
const PAGES = {
  home: HomePage,
  visibility: VisibilityDetail,
  intelligence: IntelligenceDetail,
  documents: DocumentsDetail,
  about: About,
  contact: ContactPage,
  privacy: Privacy,
};

// Scroll automático al top y manejo de anclas
const ScrollToTop = () => {
  const location = useLocation();

  React.useEffect(() => {
    if (location.hash) {
      // Si hay hash, scroll a la sección específica
      const el = document.querySelector(location.hash);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      }
    } else {
      // Si no hay hash, scroll al top instantáneo
      window.scrollTo({ top: 0, behavior: 'auto' });
    }
  }, [location.pathname, location.hash]);

  return null;
};

function App() {
  return (
    <Router>
      <LanguageProvider>
        <div className="App">
          <Header />
          <ScrollToTop />
          <Routes>
            {Object.entries(ROUTES).flatMap(([key, paths]) =>
              LANGS.map((lang) => (
                <Route
                  key={`${lang}-${key}`}
                  path={paths[lang]}
                  element={React.createElement(PAGES[key])}
                />
              ))
            )}
          </Routes>
          <Footer />
        </div>
      </LanguageProvider>
    </Router>
  );
}

export default App;
